import React, { useState, useEffect } from 'react';
import BlogCategoriesBulkDeleteModal from './BlogCategoriesBulkDeleteModal';

const BlogCategoriesBulkActions = ({ 
  selectedCategories, 
  clearSelectedCategories, 
  loadCategories 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (selectedCategories.length === 0) {
      setBulkAction('');
    }
  }, [selectedCategories]);

  const handleBulkAction = async () => {
    if (!selectedCategories.length) {
      alert('No categories selected.');
      return;
    }

    if (bulkAction === 'delete') {
      setIsBulkDeleteModalOpen(true);
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedCategories.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedCategories.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="delete">Delete</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedCategories.length === 0}
      >
        Apply
      </button>

      <BlogCategoriesBulkDeleteModal
        isOpen={isBulkDeleteModalOpen}
        onClose={() => {
          setIsBulkDeleteModalOpen(false);
          clearSelectedCategories();
        }}
        onSuccess={() => {
          loadCategories();
          setIsBulkDeleteModalOpen(false);
          clearSelectedCategories();
          setBulkAction('');
        }}
        categories={selectedCategories}
      />
    </div>
  );
};

export default BlogCategoriesBulkActions; 